import React, { useState, useEffect } from 'react';

const WinnersTable = ({ drawing, limitPerPage = 10 }) => {
    const [page, setPage] = useState(1);
    const [seeMore, setSeeMore] = useState(true);

    useEffect(() => {
        if (drawing?.winners?.length / (page * limitPerPage) > 1) {
            setSeeMore(true);
        } else {
            setSeeMore(false);
        }
    }, [drawing, page]);

    const data = JSON.parse(drawing?.data);
    return (
        <div className='winners-data'>
            <div>
                <h2 id='draw-title' className='winners-list-heading text-center mb-2'>
                    {data.game_name}
                </h2>
                <p className='text-center text-bold'>{`Drawing ${drawing?.draw_number}`}</p>
            </div>
            <div className='table-container'>
                <table className='table-panelled'>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>City</th>
                            <th>Prize</th>
                        </tr>
                    </thead>
                    <tbody>
                        {drawing?.winners?.map(({ name, city, prize }, idx) => {
                            return idx < page * limitPerPage ? (
                                <tr key={idx}>
                                    <td data-title='Name'>{name}</td>
                                    <td data-title='City'>{city}</td>
                                    <td className='prize-cell' data-title='Prize'>
                                        {prize}
                                    </td>
                                </tr>
                            ) : null;
                        })}
                    </tbody>
                </table>
            </div>
            <div className='col-12 my-3 text-center'>
                {drawing?.winners?.length > limitPerPage && (
                    <button
                        disabled={!seeMore}
                        className='theme-btn theme-btn-secondary text-uppercase mx-auto'
                        onClick={() => {
                            setPage((page) => page + 1);
                        }}>
                        See More
                    </button>
                )}
            </div>
        </div>
    );
};

export default WinnersTable;
